import { GET_STATUS_BAR } from '..';

export const getStatusBar = (payload) => ({
  type: GET_STATUS_BAR,
  payload,
});
